// Libraries
import { MouseEventHandler } from 'react';

// Styles
import styles from './BingoButton.module.css';

/**
 * @function BingoButton
 * Describe the component's function
 *
 * @example
 * return (
 *   <BingoButton text="" onClick={() => false} />
 * )
 */
function BingoButton({
    text = '',
    onClick = () => false,
    disabled = false,
}: BingoButtonProps): JSX.Element {
    return (
        <button
            className={styles.button}
            onClick={(e) => onClick(e)}
            disabled={disabled}
        >
            {text}
        </button>
    );
}

/**
 * @interface BingoButtonProps
 * Describes the properties required for the BingoButton component
 *
 * @property {string} text
 * @property {function} onClick Return function to call when clicked
 * @property {boolean} disabled
 */
export interface BingoButtonProps {
    text: string;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean;
}

// Exports
export default BingoButton;
